<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_ii"></a><a id="page_iii"></a>EYES<br/><span class="small">ON THE</span><br/>GOAL</h1>
<p class="author"><strong><span class="small">JOHN COY</span></strong></p>
<p class="image"><img alt="f0iii-01" src="images/f0iii-01.jpg"/></p>
<p class="publisher"><img alt="pub" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?9ad09b4a